import React from 'react';
import { Droplet, Beef, AlertTriangle, Gift } from 'lucide-react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL } from '../ui/Button';
const highlights = [{
  icon: <Droplet size={24} data-id="element-44" />,
  title: 'Calculadora de Hidratación Diaria',
  desc: 'Sabé exactamente cuánta agua y electrolitos necesitas según tu peso, clima y volumen de entrenamiento.'
}, {
  icon: <Beef size={24} data-id="element-45" />,
  title: 'Calculadora de Proteínas',
  desc: 'Ajustá tu ingesta proteica para optimizar la recuperación muscular sin pasarte ni quedarte corto.'
}, {
  icon: <AlertTriangle size={24} data-id="element-46" />,
  title: 'Suplementos a Evitar y Validados',
  desc: 'Lista clara y honesta de qué suplementos sí funcionan y cuáles son una pérdida de plata.'
}];
export function Includes() {
  return <section className="py-24 bg-black" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-12" data-id="element-49">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-brand-green/15 text-brand-green text-xs font-bold tracking-wider uppercase rounded-full mb-4" data-id="element-50">
            <Gift size={14} data-id="element-51" />
            Bonos exclusivos
          </span>
          <h3 className="font-serif text-3xl md:text-5xl font-bold text-white mb-3" data-id="element-52">
            Llevando HOY tenes estos bonos{' '}
            <span className="text-brand-green" data-id="element-53">GRATIS</span>
          </h3>
          <p className="text-white/70 max-w-2xl mx-auto" data-id="element-54">
            3 herramientas prácticas que se suman a tu compra sin costo
            adicional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-55">
          {highlights.map((h, i) => <motion.a key={i} href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative bg-brand-green text-brand-dark rounded-2xl p-7 hover:scale-[1.02] transition-transform cursor-pointer block" data-id="element-56">
              <div className="absolute -top-3 right-4 bg-brand-dark text-brand-green text-xs font-bold px-3 py-1 rounded-full tracking-wider" data-id="element-57">
                GRATIS
              </div>
              <div className="w-12 h-12 rounded-xl bg-brand-dark/10 text-brand-dark flex items-center justify-center mb-5" data-id="element-58">
                {h.icon}
              </div>
              <h4 className="text-lg font-bold mb-3" data-id="element-59">{h.title}</h4>
              <p className="text-brand-dark/80 leading-relaxed text-sm mb-5" data-id="element-60">
                {h.desc}
              </p>
              <div className="flex items-center gap-2 pt-4 border-t border-brand-dark/15" data-id="element-61">
                <span className="text-brand-dark/50 line-through font-semibold" data-id="element-62">
                  $15.000
                </span>
                <span className="font-bold text-sm tracking-wider" data-id="element-63">GRATIS</span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}